<template>
  <section class="my-5">

    <div class="form-content">
      <h3>マナビス化粧品ショッピング会員登録申込受付完了のお知らせ</h3>
      <p class="mt-5"><strong>マナビス化粧品</strong><small>＜info@manavis-cosme.co.jp＞</small></p>
      <p class="my-5">ショッピング会員登録申込の受付が完了致しました。</p>
      <p class="my-5">次に申込者情報の登録及び商品ご購入のお手続きとなりますので、2022/00/00 00:00:00までに下記URLをクリックするか、ブラウザのアドレス欄にコピーしていただき、表示される画面から、ご入力をお願い致します。</p>
      <p class="my-5">【登録URL】<br><router-link to="/mock/shopping/registration">https://www.manavis-cosme.co.jp/web/#/shopping/registration/◯◯◯</router-link></p>
      <p class="my-5">※このメールの内容に心あたりのない場合は、恐れ入りますが下記弊社お問い合わせ窓口までご連絡頂き、このメールは削除頂けます様、宜しくお願いします。</p>
      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        このメールは、配信専用のアドレスで配信されています。<br>
        このメールに返信頂いた内容についてはご確認、ご返答いたしかねますのであらかじめご了承ください。<br>
        このメールの内容についてのお問い合わせは、下記の連絡先までお願いします。<br>
        <br>
        株式会社マナビス化粧品お問い合わせ窓口
        電話：0120-268-510（平日：9:00～17:00）<br>
        ------------------------------------------------------------------------------------------
      </p>
    </div>
  </section>

</template>
<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
